import { BaseLocation } from "../subscription/base-locations.enum";

export interface Driver {
  base: BaseLocation;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  phoneNumber: string | null;
  userId: string;
}

export function driverToString(driver: Driver | undefined): string {
  if (!driver) {
    return "No driver found";
  }

  if (!driver.firstName && !driver.lastName) {
    return "User without name";
  }

  return `${driver.firstName ?? ""} ${driver.lastName ?? ""}`;
}
